export default __webpack_public_path__ + "static/media/five_of_swords.6b4c171c.png";